/**
 * UAVTradeZone Modification Record
 * 
 * Change ID: PHASE_2_API_CLIENT_SETUP
 * Date: 2025-01-04
 * Modified By: Cursor
 * 
 * Description:
 * Basic Axios client for making API requests, including token attachment.
 * This is a foundational service to centralize API call logic.
 * 
 * File Size Check:
 * - Current: 0 lines (new file)
 * - Target: 200 lines max (Service limit)
 */

/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    COOKIE_AUTH_MIGRATION
 * Date:         2026-02-11
 * Modified By:  Claude
 *
 * Description:
 * Updated apiClient to use HTTP-only cookies for authentication.
 * Removed Authorization header interceptor - cookies are sent automatically.
 *
 * Related Screens / Modules:
 * - server/middlewares/auth.js
 * - server/utils/cookieUtils.js
 */

import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // [2026-02-11] Cookie auth: Enable cookie handling
});

// Response interceptor for global error handling (optional, could be added later)
// apiClient.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Handle global errors, e.g., redirect to login on 401
//     if (error.response && error.response.status === 401) {
//       // window.location.href = '/login'; // Or dispatch a Redux action
//     }
//     return Promise.reject(error);
//   }
// );

export default apiClient;